module.exports = __webpack_public_path__ + "img/image07.8593bbe8.jpg";